import React from "react";
import { DayPicker } from "react-day-picker";
import type { DayButtonProps } from "react-day-picker";
import "src/assets/css/calendar-overrides.css";
import {
  ChevronCalendarLeftIcon,
  ChevronCalendarRightIcon,
} from "src/assets/icons";
import {
  DayContainer,
  DayLabel,
  CurrentDayIndicator,
  HeaderTitle,
  CalendarNavButton,
} from "./Calendar.styles";
import type { ButtonProps } from "src/components/Buttons";

const CustomDayButton = ({
  day: _day,
  modifiers,
  children,
  ...rest
}: DayButtonProps) => (
  <DayContainer
    {...rest}
    isSelected={modifiers.selected}
    isDisabled={modifiers.disabled}
  >
    <DayLabel>{children}</DayLabel>
    {modifiers.today && <CurrentDayIndicator isSelected={modifiers.selected} />}
  </DayContainer>
);

const CustomPrevIcon = ({
  onClick,
  disabled,
  className,
  style,
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <CalendarNavButton
    onClick={onClick as ButtonProps["onClick"]}
    disabled={disabled}
    className={className}
    style={style}
  >
    <ChevronCalendarLeftIcon />
  </CalendarNavButton>
);

const CustomNextIcon = ({
  onClick,
  disabled,
  className,
  style,
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <CalendarNavButton
    onClick={onClick as ButtonProps["onClick"]}
    disabled={disabled}
    className={className}
    style={style}
  >
    <ChevronCalendarRightIcon />
  </CalendarNavButton>
);

interface CalendarProps {
  selected: Date;
  onSelect: (date: Date | undefined) => void;
}

export const Calendar = ({ selected, onSelect }: CalendarProps) => {
  return (
    <div className="adp-calendar">
      <DayPicker
        animate
        mode="single"
        disabled={{ before: new Date() }}
        selected={selected}
        onSelect={onSelect}
        components={{
          DayButton: CustomDayButton,
          CaptionLabel: HeaderTitle as unknown as (
            props: React.HTMLAttributes<HTMLSpanElement>,
          ) => React.JSX.Element,
          PreviousMonthButton: CustomPrevIcon,
          NextMonthButton: CustomNextIcon,
        }}
      />
    </div>
  );
};
